import { Divider } from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";
import { fallback, appConfig as getAppConfig } from "../../app.config";
import {
  useFilters,
  useSetFilters,
  useUpdateFiltersData,
} from "../../providers/hooks/FiltersContext";
import ProductsAPI from "../../services/ProductsAPI";
import MinMaxSlider from "./MinMaxSlider";
import TextMultiSelect from "./TextMultiSelect";
import TextSelect from "./TextSelect";

export default function Filter() {
  const [appConfig, setAppConfig] = useState(fallback);
  const [initValue, setInitValue] = useState(null);
  const [dataStore, setDataStore] = useState(null);
  const filters = useFilters();
  const setFilters = useSetFilters();
  const updateFiltersData = useUpdateFiltersData();

  useEffect(() => {
    getAppConfig().then(setAppConfig);
  }, []);

  useEffect(() => {
    if (appConfig?.filters && setFilters) {
      setFilters(appConfig.filters ?? {});
    }
  }, [appConfig, setFilters]);

  useEffect(() => {
    if (!initValue) {
      ProductsAPI.getProductSizes().then((response) => {
        setInitValue(response);
        setDataStore(response);
      });
    }
  }, [initValue]);

  useEffect(() => {
    const data = {
      dataStore,
      toString: () =>
        Object.values(filters)
          .filter((filter) => !filter.isDivider)
          .map((filter) => filter.toString(dataStore))
          .join(" AND "),
      payload: () => {
        const evaluatedFilters = Object.values(filters)
          .filter((filter) => !filter.isDivider)
          .reduce(
            (prev, curr) => ({ ...prev, ...curr.payload(dataStore) }),
            {}
          );

        return Object.entries(evaluatedFilters).map(([k, v]) => {
          if (typeof v === "object") {
            return {
              name: k,
              value: JSON.stringify(v, null, 0),
            };
          }
          return {
            name: k,
            value: `${v}`,
          };
        });
      },
    };

    updateFiltersData(data);
  }, [dataStore, filters, updateFiltersData]);

  const onChange = useCallback(
    (newValue) => {
      const filter = Object.values(filters).find(
        (filter) => filter.title === newValue.title
      );

      setDataStore((current) => filter.update(current, newValue));
    },
    [filters]
  );

  function buildFilter(filter) {
    if (filter.kind === "slider")
      return (
        <MinMaxSlider
          key={filter.title}
          range={filter.minMax(initValue)}
          title={filter.title}
          onChange={onChange}
        />
      );

    if (filter.kind === "selector")
      return (
        <TextSelect
          key={filter.title}
          title={filter.title}
          options={filter.options(dataStore)}
          onChange={onChange}
        />
      );

    if (filter.kind === "multi-selector")
      return (
        <TextMultiSelect
          key={filter.title}
          title={filter.title}
          options={filter.options(dataStore)}
          onChange={onChange}
        />
      );

    if (filter.isDivider) return <Divider key={Math.random()} />;

    return <></>;
  }

  return <>{Object.values(filters).map(buildFilter)}</>;
}
